import { PUBLIC } from '@circlefin/permissions/sets'

import { LocalUnauthorizedReason } from '../../reasons'
import {
  PREQUAL_ONBOARDING,
  USER_FACTOR,
  L3_ONBOARDING,
  USER_SUPPORT,
  REMOVE_RFI_RESOLVE,
  MULTI_ENTITY_ENABLED,
} from '../../sets'

import type { PermissionPluginFn } from '@circlefin/permissions'
import type { Session } from 'next-auth'

/**
 * Handle Onboarding Permissions.
 */
export function onboardingPlugin(
  status?: Session['status'],
): PermissionPluginFn {
  return {
    verify: ({ permissionsSet, authenticated }) => {
      // Check only when the user is authenticated and have prequal status
      if (authenticated && status === 'prequal') {
        switch (permissionsSet) {
          // If onboarding is required and the permission
          // set matches, access is granted.
          case PUBLIC:
          case USER_FACTOR:
          case USER_SUPPORT:
          case PREQUAL_ONBOARDING:
          case L3_ONBOARDING:
          case REMOVE_RFI_RESOLVE:
          case MULTI_ENTITY_ENABLED:
            return {
              isAuthorized: true,
            }

          // Otherwise, deny access in all other cases
          // where onboarding is required.
          case undefined:
          default:
            return {
              isAuthorized: false,
              failureReason: LocalUnauthorizedReason.OnboardingRequired,
            }
        }
      }
    },
  }
}
